import { loadStripe } from '@stripe/stripe-js';

// Stripe publishable key - safe to expose publicly
// Live publishable key for production use
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51Q9fAPF3oiwPhVRyovBGYjlF3rM6fHW50OPloIiAwZdR8UvkYvbjeSJKXghqCOWG6wwAlSy9t2S19Ne6QwekIGUk003Ix31qAa';

// Initialize Stripe
export const stripe = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Type definitions for payment intents
export interface PaymentIntentData {
  type: 'party-pass' | 'pro-subscription';
  amount: number;
}

export interface PaymentResponse {
  clientSecret: string;
  paymentIntentId: string;
}